'use client';

import Image from 'next/image';
import Link from 'next/link';

interface LogoProps {
  variant: 'horizontal' | 'vertical' | 'symbol';
  color: 'black' | 'pink';
  customWidth?: number;
  customHeight?: number;
  className?: string;
}

const LOGO_MAP = {
  horizontal: {
    black: 'https://i.nativeteams.com/assets/app/logos/logo.svg',
    white: 'https://i.nativeteams.com/assets/app/logos/logo-white.svg',
    pink: 'https://i.nativeteams.com/assets/app/logos/logo-pink.svg',
  },
  vertical: {
    black: 'https://i.nativeteams.com/assets/app/logos/logo-vertical.svg',
    white: 'https://i.nativeteams.com/assets/app/logos/logo-vertical-white.svg',
    pink: 'https://i.nativeteams.com/assets/app/logos/logo-vertical-pink.svg',
  },
  symbol: {
    black: 'https://i.nativeteams.com/assets/app/logos/logo-symbol.svg',
    white: 'https://i.nativeteams.com/assets/app/logos/logo-symbol-white.svg',
    pink: 'https://i.nativeteams.com/assets/app/logos/logo-symbol-pink.svg',
  },
} as const;

const DIMENSIONS = {
  horizontal: { width: 164, height: 18 },
  vertical: { width: 164, height: 164 },
  symbol: { width: 32, height: 32 },
} as const;

export function Logo({
  variant = 'horizontal',
  color = 'black',
  customWidth = 164,
  customHeight = 18,
  className = '',
}: LogoProps) {
  const { width, height } =
    customWidth && customHeight
      ? { width: customWidth, height: customHeight }
      : DIMENSIONS[variant];

  return (
    <Link href="/" className="h-auto w-auto" title="Go to homepage" aria-label="Go to homepage">
      {color === 'black' ? (
        <>
          <Image
            src={LOGO_MAP[variant].black}
            alt="Native Teams Logo"
            width={width}
            height={height}
            priority
            className={`${className} block dark:hidden`}
          />
          <Image
            src={LOGO_MAP[variant].white}
            alt="Native Teams Logo"
            width={width}
            height={height}
            priority
            className={`${className} hidden dark:block`}
          />
        </>
      ) : (
        <Image
          src={LOGO_MAP[variant][color]}
          alt="Native Teams Logo"
          width={width}
          height={height}
          priority
          className={className}
        />
      )}
    </Link>
  );
}
